import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { INotificationLevelEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<INotificationLevelEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.notificationLevel");

export const notificationLevel = {
  ...getAllApis,
};
